<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-02-18 14:21:56
 * @LastEditTime: 2020-03-05 18:39:49
 -->
<template>
  <div class="ab-wrapper">
    <bs-structure
      :box-margin-r="60"
      :box-margin-l="60"
      :box-right-w="324"
    >
      <!-- header -->
      <template slot="boxHeader">
        <bs-header
          :is-show-login="false"
          :data="data"
        >
          <!-- 传data -->
        </bs-header>
      </template>
      <!-- body -->
      <template slot="boxBody">
        <bs-abnormal :type="abnormalType" />
      </template>
    </bs-structure>
  </div>
</template>
<script>
import bsHeader from 'components/business/link/header/index.vue'
import bsLang from 'components/business/lang/index.vue'
import bsStructure from 'components/business/structure/index.vue'
import bsAbnormal from 'components/business/abnormal/index.vue'

export default {
  name: 'BsInvalid',
  components: {
    bsStructure,
    bsAbnormal,
    bsLang,
    bsHeader,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
        }
      },
    },
  },
  data() {
    return {
      /**
             * 初始化外链
             *     '10001': 'bsInvalid',查不到外链信息
             *     '10002': 'bsInvalid',正在已经审核不允许通过
             *     '10003': 'bsInvalid',外链过期
             *     '10004': 'bsInvalid',审批被拒绝
             *     '10005': 'bsInvalid',发外链的账号已经过期
             *     '10006': 'bsInvalid',用户状态不正常
             *     '10007': 'bsInvalid',该外链没有开启外链功能
             *     '10008': '', 内链但没有登录
             *     '10009': '', 内链已经登录但当前用户和外链创建者不在同一企业
             *     '10000': '', 所有权限校验完成
             */
      cfg: {
        10001: 'invalidLose',
        10003: 'invalidLose',
        10005: 'invalidLose',
        10002: 'invalid',
        10004: 'invalid',
        10009: 'invalidAccess',
        10006: 'invalidLose',
        10007: 'invalidLose',
      },
    }
  },
  computed: {
    abnormalType() {
      if (this.data.ext && this.data.ext.code) {
        return this.cfg[this.data.ext.code]
      }
      return 'invalidLose'// this.data的异常类型
    },
  },
  created() {
  },
  methods: {
  },
}
</script>
<style lang="less" scoped>
@import '~less/button.less';
.ab-wrapper{
  width: 100%;
  height: 100%;
}
</style>
